<template>
    <div class="filters p-32">
        <i class="fa fa-times" aria-hidden="true"></i>
        <div class="form-c-group">
            <input type="text" v-model="name" value="" class="form-control" :placeholder="__('pages.name_search_ph')">
        </div>
        <div class="form-c-group type-container">
            <h6>{{__('pages.filter.type')}}</h6>
            <div class="mt-8 checkbox" v-for="(item, key) in type_list.slice(0, more.type)">
                <input :id="`type-${item.id}`" type="checkbox" v-model="type" :value="item.id" @change="checkFilterItem('type_list', 'type', 'type')">
                <label :for="`type-${item.id}`">{{item.name}}</label>
            </div>
            
            <button v-if="type_list.length > 4 && more.type != type_list.length" @click="more.type = type_list.length" type="button" class="btn btn-link">{{__('pages.filter.more')}}</button>
        </div>
        <div class="form-c-group">
            <h6>{{__('pages.filter.price')}}</h6>
            <div class="row">
                <div class="col-6"> 
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="price.min" @keyup="checkPrice()">
                        <div class="input-group-append">
                            <span class="input-group-text">{{__('pages.filter.min_price')}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="price.max" @keyup="checkPrice()">
                        <div class="input-group-append">
                            <span class="input-group-text">{{__('pages.filter.max_price')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-c-group equipment-container">
            <h6>{{__('pages.filter.equipment')}}</h6>
            <div class="mt-8 checkbox" v-for="(item, key) in equipment_list.slice(0, more.equipment)">
                <input :id="`equipment-${item.id}`" type="checkbox" v-model="equipment" :value="item.id" @change="checkFilterItem('equipment_list', 'equipment', 'equipment')">
                <label :for="`equipment-${item.id}`">{{item.name}}</label>
            </div>
            
            <button v-if="equipment_list.length > 4 && more.equipment != equipment_list.length" @click="more.equipment = equipment_list.length" type="button" class="btn btn-link">{{__('pages.filter.more')}}</button>
        </div>
        <div class="form-c-group service-container">
            <h6>{{__('pages.filter.service')}}</h6>
            <div class="mt-8 checkbox" v-for="(item, key) in service_list.slice(0, more.service)">
                <input :id="`service-${item.id}`" type="checkbox" v-model="service" :value="item.id" @change="checkFilterItem('service_list', 'service', 'service')">
                <label :for="`service-${item.id}`">{{item.name}}</label>
            </div>
            
            <button v-if="service_list.length > 4 && more.service != service_list.length" @click="more.service = service_list.length" type="button" class="btn btn-link">{{__('pages.filter.more')}}</button>
        </div>
        <div class="form-c-group">
            <h6>{{__('pages.filter.rating')}}</h6>
            <div class="stars d-flex" @mouseleave="setRating('set', rate)">
                <i class="fas fa-star" @mouseover="setRating('over', 1)" @mouseleave="setRating('leave', 1)" @click="setRating('click', 1)"></i>
                <i class="fas fa-star" @mouseover="setRating('over', 2)" @mouseleave="setRating('leave', 2)" @click="setRating('click', 2)"></i>
                <i class="fas fa-star" @mouseover="setRating('over', 3)" @mouseleave="setRating('leave', 3)" @click="setRating('click', 3)"></i>
                <i class="fas fa-star" @mouseover="setRating('over', 4)" @mouseleave="setRating('leave', 4)" @click="setRating('click', 4)"></i>
                <i class="fas fa-star" @mouseover="setRating('over', 5)" @mouseleave="setRating('leave', 5)" @click="setRating('click', 5)"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                type_list: [],
                equipment_list: [],
                service_list: [],
                more:{
                    type: 4,
                    equipment: 4,
                    service: 4
                },
                base_category: '',
                type: [],
                equipment: [],
                service: [],
                price: {
                    min: '',
                    max: ''
                },
                rate: 0,
                name: ''
            }
        },
        created(){
            let _self = this;
            axios(Laravel.baseApiUrl + '/properties/apartman')
            .then(function(response){
                if(response.data && response.data.length > 0){
                    _self.type_list = response.data;
                }
            });
            axios(Laravel.baseApiUrl + '/properties/equipment')
            .then(function(response){
                if(response.data && response.data.length > 0){
                    _self.equipment_list = response.data;
                }
            });
            axios(Laravel.baseApiUrl + '/properties/service')
            .then(function(response){
                if(response.data && response.data.length > 0){
                    _self.service_list = response.data;
                }
            });
            
            if(this.params){
                this.base_category = this.params.base_category ? this.params.base_category : '',
                this.type = this.params.type ? this.params.type : [],
                this.equipment = this.params.equipment ? this.params.equipment : [],
                this.service = this.params.service ? this.params.service : [],
                this.price.min = this.params.price_min ? this.params.price_min : '',
                this.price.max = this.params.price_max ? this.params.price_max : '';
                this.name = this.params.name ? this.params.name : '',

                this.$root.setParams({
                    base_category: this.params.base_category ? this.params.base_category : '',
                    type: this.params.type ? this.params.type : [],
                    equipment: this.params.equipment ? this.params.equipment : [],
                    service: this.params.service ? this.params.service : [],
                    price_min: this.params.price_min ? this.params.price_min : '',
                    price_max: this.params.price_max ? this.params.price_max : '',
                    district: this.params.district ? this.params.district : '',
                    city: this.params.city ? this.params.city : '',
                    when_start: this.params.when_start ? this.params.when_start : this.getDate(),
                    when_end: this.params.when_end ? this.params.when_end : null,
                    booking_type: this.params.booking_type ? this.params.booking_type : 1,
                    time_from: this.params.time_from ? this.params.time_from : '',
                    time_to: this.params.time_to ? this.params.time_to : '',
                    name: this.params.name ? this.params.name : '',
                });
            }
        },
        props:['params'],
        watch: {
            'price.min': _.debounce(function(){
                if(this.$root.getParam('price_min') != this.price.min){
                    this.$root.setParams({price_min: this.price.min});
                }
            }, 500),
            'price.max': _.debounce(function(){
                if(this.$root.getParam('price_max') != this.price.max){
                    this.$root.setParams({price_max: this.price.max});
                }
            }, 500),
            'rate': _.debounce(function(){
                if(this.$root.getParam('rate') != this.rate){
                    this.$root.setParams({rate: this.rate});
                }
            }, 500),
            'name': _.debounce(function(){
                if(this.$root.getParam('name') != this.name){
                    this.$root.setParams({name: this.name});
                }
            }, 500)
        },
        methods:{
            checkPrice(){
                this.price.min = parseInt(this.price.min);
                this.price.max = parseInt(this.price.max);
                if(isNaN(this.price.min)){
                    this.price.min = '';
                }

                if(isNaN(this.price.max)){
                    this.price.max = '';
                }
            },
            checkFilterItem(container, item, st){
                this[container] = this.filterItemSort(this[container], this[item], st);
                let params = {};
                params[item] = this[item];
                this.$root.setParams(params);   
            }
        }
    }
</script>